<template>
  <div class="flex h-dvh flex-col">
    <div
      v-if="hashChanged"
      class="refresh-container flex shrink-0 flex-row justify-center gap-2 bg-yellow-400 p-2 shadow-inner"
    >
      <div class="font-bold">{{ $t('toasts.new_update_1') }}</div>
      <button class="rounded bg-white px-2" @click="reloadApp">
        {{ $t('toasts.reload') }}
      </button>
    </div>
    <div
      v-if="offline"
      class="refresh-container flex shrink-0 flex-row justify-center gap-2 bg-yellow-400 p-2 shadow-inner"
    >
      <div class="font-bold">
        {{ $t('toasts.offline_description') }}
      </div>
    </div>
    <div
      v-if="dev && showLocalBanner"
      class="flex shrink-0 flex-row items-center justify-center gap-2 bg-orange-500 p-1 shadow-inner"
    >
      <div class="text-sm font-bold text-white">⚠ LOCAL</div>
    </div>
    <div
      v-if="isImpersonating"
      class="flex shrink-0 flex-row items-center justify-center gap-2 bg-violet-600 p-1 shadow-inner"
    >
      <div class="text-sm font-bold text-white">👤 {{ $t('global.impersonate.banner') }} {{ impersonatedUserName }}</div>
    </div>
    <div class="min-h-0 flex-1">
      <RouterView />
      <YouSignErrorDetailsModal />
    </div>
    <ImpersonationButton v-if="isImpersonating" />
  </div>
</template>
<script>
// mixins
import { refreshPageMixin } from '@u/mixins/refresh-page.mixin'
import YouSignErrorDetailsModal from '@c/YouSign/YouSignErrorDetailsModal.vue'
import ImpersonationButton from '@c/ImpersonationButton.vue'

export default {
  components: { YouSignErrorDetailsModal, ImpersonationButton },
  mixins: [refreshPageMixin],
  data() {
    return {
      prod: import.meta.env.PROD,
      dev: import.meta.env.DEV,
      showLocalBanner: import.meta.env.VITE_SHOW_LOCAL_BANNER !== 'false',
      isOffline: !window.navigator.onLine
    }
  },
  computed: {
    offline() {
      return this.isOffline
    },
    isImpersonating() {
      return this.$store.getters['impersonation/isImpersonating']
    },
    impersonatedUserName() {
      const user = this.$store.getters['impersonation/impersonatedUser']
      return user ? `${user.first_name} ${user.last_name}` : ''
    }
  },
  mounted() {
    console.warn(import.meta.env.VITE_SHOW_LOCAL_BANNER)
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    console.log('%c✘ Env! ' + import.meta.env.MODE, 'color: #E2AF00')
  },
  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    updateOnlineStatus() {
      this.isOffline = !window.navigator.onLine
    }
  }
}
</script>
